import React from 'react'
import { ForEachModel, useValue, ValueToCollection } from '@morningtrain/react-resources'
import moment from 'moment'
import Entry from 'pages/app/vacation/Entry'

export default function CalendarEntries () {
  const modelPeriod = useValue('period')

  const period = {
    from: modelPeriod && modelPeriod.from ? moment(modelPeriod.from) : moment().startOf('isoWeek'),
    to: modelPeriod && modelPeriod.to ? moment(modelPeriod.to) : moment().add(1, 'year')
  }

  return (
    <ForEachModel>
      <div className='entries bg-gray-700 entry-wrapper' />
      <ValueToCollection name='collection'>
        <ForEachModel>
          <div className='entries'>
            <ValueToCollection name='entries'>
              <ForEachModel>
                <Entry {...period} />
              </ForEachModel>
            </ValueToCollection>
          </div>
        </ForEachModel>
      </ValueToCollection>
    </ForEachModel>
  )
}
